import React from 'react';

/**
 * RichText
 * --------
 * Renders a plain string from the CMS with support for inline highlights.
 * Wrap any phrase in double-asterisks (**like this**) inside the CMS content
 * and it will be rendered in a brand accent color.
 *
 * Each highlighted phrase is assigned one of the three brand colors
 * (yellow, coral, pink) deterministically via a tiny character-sum hash,
 * so the same phrase always renders in the same color, but different
 * phrases distribute naturally across all three.
 *
 * Example:
 *   "ClicksyHub is the AI platform that lets **financial institutions** go..."
 */
const HL_CLASSES = ['hl hl-1', 'hl hl-2', 'hl hl-3'];

const hlClass = (phrase) => {
  let sum = 0;
  for (let i = 0; i < phrase.length; i += 1) sum = (sum + phrase.charCodeAt(i)) & 0xffff;
  return HL_CLASSES[sum % 3];
};

export default function RichText({ text, className = '' }) {
  if (!text) return null;
  const parts = [];
  const re = /\*\*([^*]+)\*\*/g;
  let last = 0;
  let m;
  let idx = 0;
  while ((m = re.exec(text)) !== null) {
    if (m.index > last) parts.push(<React.Fragment key={idx++}>{text.slice(last, m.index)}</React.Fragment>);
    parts.push(<span key={idx++} className={hlClass(m[1])}>{m[1]}</span>);
    last = m.index + m[0].length;
  }
  if (last < text.length) parts.push(<React.Fragment key={idx++}>{text.slice(last)}</React.Fragment>);
  return <span className={className}>{parts.length ? parts : text}</span>;
}
